import { PageSkeleton } from '@app/components'
import { useInbox } from '@app/features/portal/inbox'
import { useAuth } from '@app/lib/auth'
import { Navigate, useLocation } from 'react-router'
import { AppShellLayout } from './AppShellLayout'

export function PortalShell() {
  const { user, isLoading } = useAuth()
  const location = useLocation()
  if (isLoading)
    return (
      <div className="container" style={{ paddingBlock: '3rem' }}>
        <PageSkeleton />
      </div>
    )
  if (!user)
    return (
      <Navigate
        to={`/sign-in?redirectTo=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    )
  return <SignedInPortal />
}

/** Split out so the "Things to do" count is only fetched once someone is signed in. */
function SignedInPortal() {
  const todo = useInbox().items.length
  return (
    <AppShellLayout
      title="My portal"
      groups={[
        {
          items: [
            {
              to: '/portal',
              label: 'Overview',
              end: true,
              badge: todo,
              badgeLabel: `${todo} ${todo === 1 ? 'thing' : 'things'} to do`,
            },
            { to: '/portal/profile', label: 'Profile' },
            { to: '/portal/applications', label: 'Applications' },
            { to: '/portal/payments', label: 'Payments & receipts' },
            { to: '/portal/donations', label: 'Donations' },
            { to: '/portal/fundraisers', label: 'My fundraisers' },
            { to: '/portal/orders', label: 'Orders' },
            { to: '/portal/volunteering', label: 'Volunteering' },
            { to: '/portal/sponsorships', label: 'Sponsorships' },
            { to: '/portal/notifications', label: 'Notifications' },
          ],
        },
        { label: 'Site', items: [{ to: '/', label: 'Back to btownpride' }] },
      ]}
    />
  )
}
